<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dMOJSZ/tc-custom/9781571318060.jpg?1705766068149" alt="This image is the cover for the book Fancy Beasts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fancy Beasts
      </h1>
      <p class="bookDescription body article font2">
        <p><b>California wildfires, the 2008 election, plastic surgery, Larry Craig, wildfires, Wal-Mart, and rampant commercialism—in <i>Fancy Beasts</i>, Alex Lemon takes on American media culture, the obscene foil for personal legacies of violence and violation.</b></p><p>The poems of this collection are a workout: vigorous and raw, frenetic and fearless. Yet they are also composed and controlled, pared down and sculpted, with a disarming narrative simplicity and directness. Even when dealing with toxic content—including the turning point in a life of abuse, in which the recovering victim/perpetrator puzzles through the paradigm of son-to-husband-to-father—Lemon’s point of view is always genuine and trustworthy.</p><p>A frank, funny, and inimitably frenetic vision of post-millennial America, <i>Fancy Beasts</i> is a stunning achievement from Alex Lemon.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Lemon
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Perseus
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8295cb78